import React from 'react'
import Link from 'next/link'

import {t} from '@lib/helpers'
import {footerCertifications, footerIcons, footerSocials} from './constant'

export default function Footer() {
  const key = (name) => `pages.partnerAws.footer.${name}`

  return (
    <footer className='PartnerAws__footer'>
      <div className='PartnerAws__footer__inner'>
        <div className='PartnerAws__footer__info'>
          <div className='PartnerAws__footer__brand'>
            <img
              className='PartnerAws__footer__logo'
              src='/images/logo-white.svg'
              alt='Data Wow'
            />
            <div className='PartnerAws__footer__certs'>
              {footerCertifications.map((cert) => (
                <img
                  key={cert.src}
                  src={cert.src}
                  alt={cert.alt}
                  loading='lazy'
                />
              ))}
            </div>
          </div>

          <div className='PartnerAws__footer__details'>
            <div className='PartnerAws__footer__details__row'>
              <div className='PartnerAws__footer__block'>
                <p className='PartnerAws__footer__block__title'>
                  {t(key('addressTitle'))}
                </p>
                <p className='PartnerAws__footer__address'>
                  {t(key('address'))}
                </p>
              </div>

              <div className='PartnerAws__footer__block'>
                <p className='PartnerAws__footer__block__title'>
                  {t(key('contactTitle'))}
                </p>
                <a
                  className='PartnerAws__footer__contact'
                  href={`tel:${t(key('phone')).replace(/[^0-9+]/g, '')}`}
                >
                  <img src={footerIcons.call} alt='' />
                  <span>{t(key('phone'))}</span>
                </a>
                <a
                  className='PartnerAws__footer__contact'
                  href={`mailto:${t(key('email'))}`}
                >
                  <img src={footerIcons.mail} alt='' />
                  <span>{t(key('email'))}</span>
                </a>
              </div>
            </div>

            <div className='PartnerAws__footer__block'>
              <p className='PartnerAws__footer__block__title'>
                {t(key('followTitle'))}
              </p>
              <div className='PartnerAws__footer__socials'>
                {footerSocials.map((social) => (
                  <a
                    key={social.key}
                    href={social.href}
                    title={social.label}
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                  >
                    <img src={social.icon} alt={social.label} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='PartnerAws__footer__legal'>
          <div className='PartnerAws__footer__legal__links'>
            <Link href='/policy'>
              <a>{t(key('privacyPolicy'))}</a>
            </Link>
            <Link href='/security'>
              <a>{t(key('security'))}</a>
            </Link>
          </div>
          <p className='PartnerAws__footer__copyright'>
            &copy; {t(key('copyright'))}
          </p>
        </div>
      </div>
    </footer>
  )
}
